/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmJob {
    getFixupPrototypeFunction() { return AwsSsmJob.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmJob>): AwsSsmJob {
        let obj = Object.assign(new AwsSsmJob(), model);
        AwsSsmJob.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmJob>): AwsSsmJob {
        if (!model) return null;
        return AwsSsmJob.newInstance(<AwsSsmJob> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmJob) {
        if (!obj) return;

        models.AwsSsmJob.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmJob): boolean {
        Object.setPrototypeOf(obj, AwsSsmJob.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.execution_start_time === "string") {
            this.execution_start_time = new Date(<string><any>this.execution_start_time);
        }
        if (typeof this.execution_end_time === "string") {
            this.execution_end_time = new Date(<string><any>this.execution_end_time);
        }
        if (this.execution_parameters) {
            models.AwsSsmBaseExecution.fixupPrototype(this.execution_parameters);
        }
    }

    /**
     * Id of the Job Execution
     */
    sysId: string;

    /**
     * ID of the group job.
     */
    group_job_id: string;

    /**
     * ID of the parent job if the execution document is child.
     */
    parent_job_id: string;

    /**
     * ID of the cloud account for which document is executed.
     */
    cloud_account_id: string;

    /**
     * AWS region where the document is executed.
     */
    region: string;

    /**
     * Automation or command document execution id.
     */
    execution_id: string;

    /**
     * Start time of document execution.
     */
    execution_start_time: Date;

    /**
     * End time of document execution.
     */
    execution_end_time: Date;

    /**
     * Status of the Automation Execution
     */
    status: models.AwsSsmAutomationExecutionStatus;

    /**
     * Name of the document that is executed
     */
    document_name: string;

    /**
     * Input parameter details of the execution
     */
    execution_parameters: models.AwsSsmBaseExecution;

}
